<template>
	<v-container>
		<v-row class="text-center">
			<v-col cols="12">
				<v-img :src="require('../assets/logo.svg')" class="my-3" contain height="200" />
			</v-col>

			<v-col class="mb-4">
				<h1 class="display-2 font-weight-bold mb-3">Bienvenido</h1>

				<p class="subheading font-weight-regular">
					Completa el formulario con tus datos personales,
					<br />please join our online
				</p>
			</v-col>

			<v-col class="mb-5" cols="12">
				<v-btn class="primary"> Llenar formulario </v-btn>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
export default {
	name: "HelloWorld",

	data: () => ({}),
};
</script>
